/* eslint-disable react/jsx-closing-tag-location, no-nested-ternary, object-property-newline, react/jsx-one-expression-per-line, operator-linebreak, indent */
/** Dala chegarasini sun'iy yo'ldosh xaritasida KO'RISH (faqat o'qish).
 * Chizish/tahrirlash — mobil ilovada. Leaflet — CDN'dan (leafletLoader). */
import React, { useEffect, useRef, useState } from 'react'
import { loadLeaflet, SATELLITE_URL } from './leafletLoader'

export default function FieldMap({ boundary, height = 280 }) {
    const containerRef = useRef(null)
    const [failed, setFailed] = useState(false)

    useEffect(() => {
        if (!containerRef.current || !boundary) return undefined
        const ring = (boundary.coordinates && boundary.coordinates[0]) || []
        // GeoJSON: [lng, lat] -> Leaflet: [lat, lng]
        const latlngs = ring.map(([lng, lat]) => [lat, lng])
        if (latlngs.length < 3) return undefined

        let map = null
        let cancelled = false
        loadLeaflet().then((L) => {
            if (cancelled || !containerRef.current) return
            map = L.map(containerRef.current, {
                attributionControl: false,
                scrollWheelZoom: false,
            })
            L.tileLayer(SATELLITE_URL, { maxZoom: 19 }).addTo(map)
            const polygon = L.polygon(latlngs, {
                color: '#D97757', weight: 2.5, fillOpacity: 0.3,
            }).addTo(map)
            map.fitBounds(polygon.getBounds(), { padding: [16, 16] })
        }).catch(() => { if (!cancelled) setFailed(true) })

        return () => {
            cancelled = true
            if (map) map.remove()
        }
    }, [boundary])

    if (!boundary) return null
    if (failed) {
        return (
            <p className="has-text-grey is-size-7 p-3">
                Xarita yuklanmadi (internet/CDN). Chegara mobil ilovada ko‘rinadi.
            </p>
        )
    }
    return (
        <div ref={containerRef}
            style={{ height, borderRadius: 8, overflow: 'hidden', zIndex: 0 }} />
    )
}
